module.exports = __webpack_public_path__ + "img/oldForest-3018-09-26.be951851.jpg";